export default function Footer() {
  return (
    <footer className="bg-[#1A252F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-8 items-start">
          {/* Left Column */}
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/e86a6f0dbefd24b3e1189eb9e611dc93/7c61be3b6b8d3cb94d91107e87372ed6.png"
                alt="Quereda y Murcia Abogados"
                className="h-16 w-auto mb-4"
              />
            </div>
            <div className="text-white/80 text-sm space-y-2">
              <p>
                <a 
                  href="https://www.google.com/maps?cid=3023301393433464636"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#A77047] transition-colors cursor-pointer"
                >
                  C. San Lorenzo 6, 30001 Murcia
                </a>
              </p>
              <p>
                Teléfono: <a href="tel:968213493" className="hover:text-[#A77047] transition-colors cursor-pointer">968 21 34 93</a>
              </p>
              <p>
                Mail: <a href="mailto:queredaymurciaabogados@gmail.com" className="hover:text-[#A77047] transition-colors cursor-pointer">queredaymurciaabogados@gmail.com</a>
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="md:text-right">
            <nav className="space-y-2">
              <a href="#" className="block text-white/80 hover:text-[#A77047] text-sm transition-colors cursor-pointer">
                Política de Cookies
              </a>
              <a href="#" className="block text-white/80 hover:text-[#A77047] text-sm transition-colors cursor-pointer">
                Aviso Legal
              </a>
              <a href="#contacto" className="block text-white/80 hover:text-[#A77047] text-sm transition-colors cursor-pointer">
                Contacto
              </a>
              <a href="#" className="block text-white/80 hover:text-[#A77047] text-sm transition-colors cursor-pointer">
                Política de Privacidad
              </a>
            </nav>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-white/60 text-sm">
            © 2026 Quereda Y Murcia Abogados
          </p>
        </div>
      </div>
    </footer>
  );
}